import axios from 'axios'

import * as types from './mutation-types'
import * as api from '@/api/url'
import { getInfo } from '@/assets/func'

export const loginRequset = ({commit}, loginInfo) => {
  let data = {
    cmd: 'auth',
    uid: loginInfo.id,
    pwd: loginInfo.pwd
  }

  axios.post(api.loginRequest, data).then((response) => {
    let userInfo = {
      uid: loginInfo.id,
      data: response.data
    }

    commit(types.SET_USER_INFO, userInfo)
  }, (err) => {
    console.error(err)
  })
}

export const getCampaginList = ({ commit }) => {
  // params -> &uid=[사용자ID]
  let uid = getInfo().uid
  let url = api.getCampaignList + uid

  axios.get(url).then((response) => {
    let res = {}
    if (response.status === 200) {
      res.status = true
      res.data = response.data
      commit(types.SET_CAMPAIGN_LIST, {list: res})
    }
  }, (err) => {
    console.error(err)
  })
}

export const getDashboardData = ({commit}) => {
  // params -> &uid=[사용자ID]
  let uid = getInfo().uid
  let url = api.getDashboard + uid

  axios.get(url).then((response) => {
    commit(types.SET_DASHBOARD_DATA, {data: response.data})
  }, (err) => {
    console.error(err)
  })
}

// export const setGangnamData = ({commit}, params) => {
//   let uid = getInfo().uid
//   let data = {
//     cmd: 'insert',
//     uid: uid,
//     data: params
//   }

//   return axios.post(api.insertGangnam, data).then((response) => {
//     return response.data
//   }, (err) => {
//     console.error(err)
//   })
// }



// WEBPACK FOOTER //
// ./src/vuex/actions.js